































import Vue from 'vue'
import BeautifulChat from '@/components/VueBeautifulChat'
import demoContent from './demoContent'
import defaultcss from './defaultcss'
import './Chat.scss'
import { ChatColorStyle, ChatMessage, ChatParticipant, ChatWidget } from '@/types/chatwidget'
import { UserProfile } from '@/types/users'
import { KeyDict } from '@/types'
import { InvitedCaster } from '@/types/casts'

export default Vue.extend({
  name: 'Chat',
  components: {
    BeautifulChat
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isWidget: {
      type: Boolean,
      required: false,
      default: false
    },
    css: {
      type: Object,
      required: true
    },
    boxWidth: {
      type: Number,
      required: false
    },
    boxHeight: {
      type: Number,
      required: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    textFontScaleFactor: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    defaultcss: defaultcss,
    icons: {
      open: {
        img: require('@/components/VueBeautifulChat/assets/logo-no-bg.svg'),
        name: 'default'
      },
      close: {
        img: require('@/components/VueBeautifulChat/assets/close-icon.png'),
        name: 'default'
      },
      file: {
        img: require('@/components/VueBeautifulChat/assets/file.svg'),
        name: 'default'
      },
      closeSvg: {
        img: require('@/components/VueBeautifulChat/assets/close.svg'),
        name: 'default'
      }
    },
    titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
    isChatOpen: false, // to determine whether the chat window should be open or closed
    colors: {
      header: {
        bg: '#F24637',
        text: '#ffffff'
      },
      launcher: {
        bg: '#4e8cff'
      },
      messageList: {
        bg: '#ffffff'
      },
      userInput: {
        bg: '#f4f7f9',
        text: '#565867'
      }
    }, // specifies the color scheme for the component
    scrollInterval: null as null | NodeJS.Timeout,
    height: 100,
    width: 100,
    now: 0,
    timeinterval: null as null | NodeJS.Timeout,
    messageStyling: true // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
  }),
  watch: {
    userColors: {
      handler () {
        // TODO, this is ugle, but dont know how to fix it
        // @ts-ignore
        this.$refs.chat.$children[0].$children[1].$children.forEach(child => {
          setTimeout(() => {
            try {
              child.calculateMessageStyle()
            } catch (_error) {
            }
          }, 100)
        })
      },
      deep: true
    }
  },
  computed: {
    chat (): ChatWidget {
      return this.$store.direct.state.chatwidget.widget
    },
    castTeam (): UserProfile[] {
      return this.$store.direct.state.events.castTeam
    },
    onlineUsers (): KeyDict<InvitedCaster> {
      return this.$store.direct.state.events.currentCast.invited_casters
    },
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    style (): Partial<CSSStyleDeclaration> {
      const height = this.height
      return {
        'fontFamily': this.getValue('general', 'font'),
        'fontSize': this.getValue('general', 'fontsize') * (height / 250) * this.textFontScaleFactor + 'px'
      }
    },
    userColors (): ChatColorStyle[] {
      const style: ChatColorStyle[] = []
      for (const index of [1, 2, 3, 4]) {
        style.push({ bg: this.getValue(`user${index}`, 'bg'), text: this.getValue(`user${index}`, 'text') })
      }
      return style
    },
    participants (): ChatParticipant[] {
      if (this.id === 'demo') {
        const userlist = demoContent.participants
        userlist.forEach((user, index) => {
          user.colors = this.userColors[index % this.userColors.length]
        })
        return userlist
      }
      const users: ChatParticipant[] = []
      let avatar = ''
      if (!this.castTeam || !this.onlineUsers) return []
      for (const message of this.chat.messages) {
        const author = message.author
        const found = users.find(user => user.id === author)
        if (!found) {
          const teammember = this.castTeam.find(teammember => teammember.id === author)
          const colors = this.userColors[users.length % this.userColors.length]
          let userdoc = {
            id: author,
            name: 'External User',
            colors,
            initials: 'Ex',
            imageUrl: ''
          }
          if (teammember) {
            if (teammember.id === this.currentUserId) {
              avatar = teammember.avatar || ''
            }
            userdoc = {
              id: teammember.id,
              name: teammember.display_name ? teammember.display_name : `${teammember.first_name} ${teammember.last_name}`,
              colors,
              initials: `${teammember.first_name[0]}${teammember.last_name[0]}`,
              imageUrl: teammember.avatar || ''
            }
          }
          users.push(userdoc)
        }
      }
      users.push({
        id: 'me',
        name: 'me',
        initials: 'me',
        imageUrl: avatar
      })
      return users
    },
    meUsers (): string[] {
      const users: string[] = []
      if (!this.isWidget) {
        users.push(this.currentUserId)
      } else {
        this.participants.forEach((user, index) => {
          if (index % 2) {
            users.push(user.id)
          }
        })
      }
      return users
    },
    messageList (): ChatMessage[] {
      if (this.id === 'demo') {
        const messages = demoContent.messageList
        messages.forEach(message => { message.timestamp = (new Date()).getTime() - 130000 })
        return messages
      }
      const messages: ChatMessage[] = []
      this.chat.messages.forEach(mess => {
        const message: ChatMessage = JSON.parse(JSON.stringify(mess))
        message.user = message.author
        if (this.meUsers.includes(message.author)) {
          message.author = 'me'
          if (!this.isWidget) {
            message.editable = true
          }
        }
        if (!message.deleted) {
          messages.push(message)
        }
      })
      return messages.slice(0).slice(-10)
    },
    newMessagesCount (): number {
      return this.chat.messages.length
    },
    showTypingIndicator (): string {
      if (!this.chat || !this.chat.istyping) {
        return ''
      }
      const user = Object.keys(this.chat.istyping).find(user => {
        const time = this.chat.istyping[user]
        return time > this.now - 2000
      })
      if (!user) {
        return ''
      } else {
        return user !== this.currentUserId ? 'visible' : ''
      }
    }
  },
  mounted () {
    if (this.id !== 'demo') {
      this.$store.dispatch('chatwidget/subscribe', this.id)
    }
    this.updateSize()
    this.scrollInterval = setInterval(() => {
      this.updateSize()
    }, 2000)
    this.timeinterval = setInterval(() => {
      this.now = (new Date()).getTime()
    }, 1000)
  },
  beforeDestroy () {
    if (this.id !== 'demo') {
      this.$store.dispatch('chatwidget/unsubscribe', this.id)
    }
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval)
    }
  },
  methods: {
    sendMessage (message) {
      message.author = this.currentUserId
      this.$store.dispatch('chatwidget/addMessage', message).catch(error => {
        console.error(`Error adding message to chat ${error}`)
      })
    },
    updateSize () {
      let windowElement: HTMLElement|undefined = undefined
      try {
        // @ts-ignore
        windowElement = this.$refs.chat.$children[0].$children[1].$el
      } catch (error) {}
      if (windowElement === undefined) return
      if (this.isWidget) {
        windowElement.scrollTo(0, 1000000)
      }
      const clientHeight = windowElement.clientHeight
      const clientWidth = windowElement.clientWidth
      if (this.height !== clientHeight) {
        this.height = clientHeight
      }
      if (this.width !== clientWidth) {
        this.width = clientWidth
      }
    },
    getImageUrl (userid) {
      const participant = this.participants.find(user => user.id === userid)
      if (!participant) return ''
      return participant.imageUrl
    },
    getInitials (userid) {
      const participant = this.participants.find(user => user.id === userid)
      if (!participant) return ''
      return participant.initials
    },
    openChat () {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false
    },
    handleRemove (message) {
      this.$store.dispatch('chatwidget/delete', message)
    },
    handleScrollToTop () {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType () {
      this.$store.dispatch('chatwidget/istyping', this.currentUserId).catch(error => {
        console.error(`Error setting typing to chat ${error}`)
      })
    },
    editMessage (message: ChatMessage) {
      const m = this.messageList.find(m => m.id === message.id)
      if (m === undefined) return
      m.isEdited = true
      m.data.text = message.data.text
    },
    getValue (component, tag) {
      let value = (this.defaultcss[component] && this.defaultcss[component][tag])
      if (!value) {
        console.error(`Default CSS for ${component} / ${tag} not existing`)
        value = 0
      }
      if (this.css[component] && this.css[component][tag]) {
        value = this.css[component][tag]
      }
      return value
    }
  }
})
